/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type Feedback = (typeof Feedback)[keyof typeof Feedback];

export const Feedback = {
  NUMBER_1: 1,
  NUMBER_0: 0,
  NUMBER_MINUS_1: -1,
} as const;
